import { FunctionalComponent } from 'preact';

import { useLayoutEffect } from 'preact/hooks';
import clsx from 'clsx';
import { IconSource, toIconElement } from '@accedo/ctv-ui-icons';
import { SplashCssModule, SplashProps } from '##/components/SplashScreen/types';
import NZOSFullLogo from '##/assets/images/svg/NZOSFullLogo.svg';
import defaultStyles from './SplashScreen.module.scss';

export const SplashScreen: FunctionalComponent<SplashProps> = ({ logo, styling }) => {
  const styles = styling && styling.cssModule ? styling.cssModule : (defaultStyles as unknown as SplashCssModule);
  const logoSrc = logo && logo.src ? logo.src : NZOSFullLogo;
  const logoAttributes =
    logo && logo.attributes
      ? logo.attributes
      : {
          viewBox: '0 0 1920 1080',
        };

  useLayoutEffect(() => {
    let staticSplash = document.getElementById('static-splash');

    /* Removes the static splash when the js bundle is loaded in the client. */
    if (staticSplash) {
      document.body.removeChild(staticSplash);
      staticSplash.remove();
      staticSplash = null;
    }
  }, []);

  return (
    <div
      id="splash-screen"
      key="splash-screen"
      className={clsx(styles.splashContainer, styling?.className)}
      style={styling?.inlineStyle}
    >
      {toIconElement(logoSrc as IconSource, { attributes: logoAttributes })}
    </div>
  );
};
